// Function that returns 'translation getter' function (the inner function)
const languageLookup = (SETTING) => (f) => {
    try {
        return TRANS[f][SETTING] === 'lorem'
            ? `(${f}) Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur, neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum quasi quidem quibusdam.`
            : TRANS[f][SETTING];
    } catch {
        return `[TRANSLATION MISSING: ${f}]`;
    }
};

export default languageLookup;

const TRANS = {
    'en': {
        DEBUG: '[English]',
        EN: 'English',
        FR: 'Anglais',
        ES: 'Inglés',
    },
    'it': {
        DEBUG: '[Italian]',
        EN: 'Italian',
        FR: 'Italien',
        ES: 'Italiano',
    },
    'es': {
        DEBUG: '[Spanish]',
        EN: 'Spanish',
        FR: 'Espagnol',
        ES: 'Español',
    },
    'de': {
        DEBUG: '[German]',
        EN: 'German',
        FR: 'Allemand',
        ES: 'Alemán',
    },
    'sl': {
        DEBUG: '[Slovenian]',
        EN: 'Slovenian',
        FR: 'Slovène',
        ES: 'Esloveno',
    },
    'he': {
        DEBUG: '[Hebrew]',
        EN: 'Hebrew',
        FR: 'Hébreu',
        ES: 'Hebreo',
    },
    'el': {
        DEBUG: '[Greek]',
        EN: 'Greek',
        FR: 'Grec',
        ES: 'Griego',
    },
    'ja': {
        DEBUG: '[Japanese]',
        EN: 'Japanese',
        FR: 'Japonais',
        ES: 'Japonés',
    },
    'ko': {
        DEBUG: '[Korean]',
        EN: 'Korean',
        FR: 'Coréen',
        ES: 'Coreano',
    },
    'sr': {
        DEBUG: '[Serbian]',
        EN: 'Serbian',
        FR: 'Serbe',
        ES: 'Serbio',
    },
    'zh': {
        DEBUG: '[Simplified Chinese]',
        EN: 'Chinese',
        FR: 'Chinois',
        ES: 'Chino',
    },
    'tr': {
        DEBUG: '[Turkish]',
        EN: 'Turkish',
        FR: 'Turc',
        ES: 'Turco',
    },
    'uk': {
        DEBUG: '[Ukrainian]',
        EN: 'Ukrainian',
        FR: 'Ukrainien',
        ES: 'Ucranio',
    },
    'pt': {
        DEBUG: '[Portuguese]',
        EN: 'Portuguese',
        FR: 'Portugais',
        ES: 'Portugués',
    },
    'hu': {
        DEBUG: '[Hungarian]',
        EN: 'Hungarian',
        FR: 'Hongrois',
        ES: 'Húngaro',
    },
    'sv': {
        DEBUG: '[Swedish]',
        EN: 'Swedish',
        FR: 'Suédois',
        ES: 'Sueco',
    },
    'ru': {
        DEBUG: '[Russian]',
        EN: 'Russian',
        FR: 'Russe',
        ES: 'Ruso',
    },
    'fa': {
        DEBUG: '[Farsi]',
        EN: 'Farsi',
        FR: 'Farsi',
        ES: 'Farsi',
    },
    'pl': {
        DEBUG: '[Polish]',
        EN: 'Polish',
        FR: 'Polonais',
        ES: 'Polaco',
    },
    'ro': {
        DEBUG: '[Romanian]',
        EN: 'Romanian',
        FR: 'Roumain',
        ES: 'Rumano',
    },
    'sq': {
        DEBUG: '[Albanian]',
        EN: 'Albanian',
        FR: 'Albanés',
        ES: 'Albanés',
    },
    'ar': {
        DEBUG: '[Arabic]',
        EN: 'Arabic',
        FR: 'Arabe',
        ES: 'Arábica',
    },
    'bg': {
        DEBUG: '[Bulgarian]',
        EN: 'Bulgarian',
        FR: 'Bulgare',
        ES: 'Búlgaro',
    },
    'hr': {
        DEBUG: '[Croatian]',
        EN: 'Croatian',
        FR: 'Croate',
        ES: 'Croata',
    },
    'cz': {
        DEBUG: '[Czech]',
        EN: 'Czech',
        FR: 'Tchèque',
        ES: 'Checo',
    },
    'fi': {
        DEBUG: '[Finnish]',
        EN: 'Finnish',
        FR: 'Finlandais',
        ES: 'Finlandés',
    },
    'id': {
        DEBUG: '[Indonesian]',
        EN: 'Indonesian',
        FR: 'Indonésien',
        ES: 'Indonesio',
    },
    'nl': {
        DEBUG: '[Netherlands]',
        EN: 'Dutch',
        FR: 'Néerlandais',
        ES: 'Holandés',
    },
    'ca': {
        DEBUG: '[Catalan]',
        EN: 'Catalan',
        FR: 'Catalan',
        ES: 'Catalán',
    },
    'ka': {
        DEBUG: '[Georgian]',
        EN: 'Georgian',
        FR: 'Géorgien',
        ES: 'Georgiano',
    },
    'da': {
        DEBUG: '[Danish]',
        EN: 'Danish',
        FR: 'Danois',
        ES: 'Danés',
    },
    'et': {
        DEBUG: '[Estonian]',
        EN: 'Estonian',
        FR: 'Estonien',
        ES: 'Estonio',
    },
    'hi': {
        DEBUG: '[Hindi]',
        EN: 'Hindi',
        FR: 'Hindi',
        ES: 'Hindi',
    },
    'lt': {
        DEBUG: '[Lithuanian]',
        EN: 'Lithuanian',
        FR: 'Lituanien',
        ES: 'Lituano',
    },
    'no': {
        DEBUG: '[Norwegian]',
        EN: 'Norwegian',
        FR: 'Norvégien',
        ES: 'Noruego',
    },
    'no_matches_found': {
        DEBUG: '[no_matches_found]',
        EN: 'No matches found',
        FR: 'Aucun résultat',
        ES: 'No hay coincidencias',
    },
    'biography_button': {
        DEBUG: '[biography_button]',
        EN: 'biography',
        FR: 'biographie',
        ES: 'biografía',
    },
    'home_button': {
        DEBUG: '[home_button]',
        EN: 'home',
        FR: 'accueil',
        ES: 'página principal',
    },
    'about_button': {
        DEBUG: '[about_button]',
        EN: 'about',
        FR: 'à propos',
        ES: 'a propósito',
    },
    'persons-and-categories': {
        DEBUG: '[persons-and-categories]',
        EN: 'Persons and Categories',
        FR: 'Personnes et catégories',
        ES: 'Personas y categorias',
    },
    'search-results': {
        DEBUG: '[search-results]',
        EN: 'Search Results',
        FR: 'Résultats de recherche',
        ES: 'Resultados de la búsqueda',
    },
    'site_title': {
        DEBUG: '[site_title]',
        EN: 'The Eric Hobsbawm Bibliography',
        FR: "La Bibliographie d'Eric Hobsbawm",
        ES: 'La Bibliografía de Eric Hobsbawm',
    },
    'welcome_h1': {
        DEBUG: '[welcome_h1]',
        EN: 'Welcome to the Eric Hobsbawm Bibliography',
        FR: "Bienvenue à La Bibliographie d'Eric Hobsbawm",
        ES: 'Bienvenidos a la Bibliografía de Eric Hobsbawm',
    },
    'welcome_p1': {
        DEBUG: 'lorem',
        EN: `The Eric Hobsbawm Bibliography provides the first 
            comprehensive bibliography of the Marxist historian <react:link href="/biography">Eric Hobsbawm</react:link> (1917-2012). 
            It has over 3,000 entries, including details of every published book, 
            journal article, book chapter, review, newspaper article and pamphlet he ever wrote, 
            along with his unpublished work and his private papers. 
            You can search the bibliography by using the search box below or, 
            if you are interested in a particular topic, you can browse the thematic lists. 
            For more information, see the <react:link href="/about#guide">user guide</react:link>.`,
        FR: `La Bibliographie d'Eric Hobsbawm est la première bibliographie intégrale de l'historien marxiste <react:link href="/biography">Eric Hobsbawm</react:link> (1917-2012). Elle contient plus de 3,000 entrées, dont les détails de tous les ouvrages, articles, critiques, et essais publiés au long de sa carrière. Elle comprend également une recension complète de ses travaux inédits et de ses archives personnelles. La recherche s’effectue soit directement par mots-clés, soit en cliquant sur une des bibliographies thématiques ci-dessous. Pour plus d'informations, reportez-vous <react:link href="/about#guide">au mode d'emploi du site</react:link>.`,
        ES: 'La Bibliografía de Eric Hobsbawm es la primera bibliografía completa del historiador marxista <react:link href="/biography">Eric Hobsbawm</react:link> (1917-2012). Contiene más de 3.000 entradas, incluidos detalles de todas las obras, artículos, reseñas y ensayos publicados a lo largo de su carrera. También incluye una revisión completa de su trabajo inédito y sus archivos personales. Se puede buscar directamente por palabra clave o haciendo clic en una de las bibliografías temáticas que figuran a continuación. Para más información, consulte la <react:link href="/about#guide">guía del usuario</react:link>.', 
    },
    'biography_h1': {
        DEBUG: '[biography_h1]',
        EN: 'Biography of Eric Hobsbawm',
        FR: 'Biographie d’Eric Hobsbawm',
        ES: 'La biografía de Eric Hobsbawm',
    },
    'about_h1': {
        DEBUG: '[about_h1]',
        EN: 'About the Bibliography',
        FR: 'A propos de la bibliographie',
        ES: 'Sobre la bibliografía',
    },
    /*
    'about_text': {
        DEBUG: 'lorem',
        EN:
            '<p>This website forms part of a research project entitled 
            ‘An Intellectual Biography of Eric Hobsbawm’, funded by the\n
            United Kingdom Arts and Humanities Research Council under grant number AH/P008720/1. 
            The grant was awarded\n
            to Emile Chabal (University of Edinburgh) and ran from December 2017 to June 2020.</p>
            \n\n
            <p>The website was built by a team composed 
            of <react:link href="https://emilechabal.com/">Emile Chabal</react:link>\n
            (principal investigator), <react:link href="https://www.oeaw.ac.at/acdh/team/current-team/richard-hadden/">Richard Hadden</react:link> (research technologist), and <react:link href="https://ucdavis.academia.edu/AnneMarino">Anne Perez</react:link> (postdoctoral researcher).</p>\n\n        <p>The team was assisted by Keith McClelland who compiled the first complete bibliography of Eric Hobsbawm’s writing in 1982, \n        which was published in Raphael Samuel & Gareth Stedman Jones (eds.), <em>Culture, Ideology and Politics: Essays for Eric Hobsbawm</em> (Routledge, 1982). Keith revised the bibliography several times before and after Hobsbawm’s death in 2012. The team are extremely grateful for his cooperation and generosity; without his efforts, this online bibliography would not have been possible.</p>\n        <p>The organisation and cataloguing of Eric Hobsbawm’s archive were completed by archivists at the Modern Records Centre, University of Warwick. The website team wishes to thank, in particular, Elizabeth Wood for her help in providing a copy of the archival catalogue database in an accessible format.</p>\n        <p>The team would also like to acknowledge the assistance of Karen Howie in helping to prepare the original grant application and the College of Arts, Humanities and Social Sciences <react:link href="https://www.ed.ac.uk/arts-humanities-soc-sci/about-us/staff-contacts/college-office-staff-teams/chief-information-officer/web-team">Digital Innovation Team</react:link> for providing logistical and technical support throughout the project.</p>\n        <p>Note that the bibliography database and archive catalogue are correct as of May 2020. The team will endeavour to process corrections, additions and amendments as soon as they are notified of them.</p> \n        <p>For any correspondence relating to the bibliography, including technical queries, please e-mail Emile Chabal (emile.chabal@ed.ac.uk). 
            For any correspondence related to Hobsbawm’s archives, 
            please contact the Modern Records Centre, University of Warwick.</p>\n',
        FR:
            '<p>Cette bibliographie fait partie d’un projet de recherche intitulé «An intellectual biography of Eric Hobsbawm», financé par le Arts and Humanities Research Council du Royaume-Uni sous le numéro de subvention AH/P008720/1. La financment a été décernée à Emile Chabal (University of Edinburgh) et s’est déroulée de décembre 2017 à juin 2020.</p><p> Le site a été construit par une équipe composée d’Emile Chabal (chercheur principal), Richard Hadden (concepteur web) et Anne Perez (chercheuse postdoctorale). L’équipe a été assistée par Keith McClelland, l’auteur de la première bibliographie complète des écrits d’Eric Hobsbawm en 1982 qui a été publiée dans Raphael Samuel & Gareth Stedman Jones (ed.), Culture, Ideology and Politics: Essays for Eric Hobsbawm (Routledge, 1982). Keith a révisé la bibliographie plusieurs fois avant et après la mort de Hobsbawm en 2012. L’équipe tient à le remercier vivement pour sa coopération et sa générosité, sans quoi cette bibliographie en ligne n’aurait pas été possible.</p><p> L’organisation et le dépouillement des archives d’Eric Hobsbawm a été fait par des archivistes du Modern Records Centre de l’Université de Warwick. L’équipe tient à remercier en particulier Elizabeth Wood pour avoir fourni une copie de la base de données du catalogue d’archives dans un format accessible. L’équipe tient également à remercier Karen Howie pour son aide dans la préparation de la demande de subvention originale et la College of Arts, Humanities and Social Sciences Digital Innovation Team pour son soutien logistique tout au long du projet. Veuillez noter que la base de données bibliographique et le catalogue d’archives ont été mis à jour en mai 2020. L’équipe s’efforcera de traiter les corrections, ajouts et modifications dès qu’ils en seront informés. </p><p>Pour toute correspondance relative à la bibliographie, y compris les questions techniques, veuillez envoyer un e-mail à Emile Chabal (emile.chabal@ed.ac.uk). Pour toute correspondance relative aux archives de Hobsbawm, veuillez contacter le Modern Records Center, University of Warwick.</p>',
        ES:
            '<p>Esta bibliografía forma parte de un proyecto de investigación titulado ‘An Intellectual Biography of Eric Hobsbawm’, financiado por el Arts and Humanities Research Council con el número de subvención AH/P008720/1. La subvención se otorgó a Emile Chabal (University of Edinburgh) y se ejecutó desde diciembre de 2017 hasta junio de 2020.</p><p> El sitio web fue construido por un equipo compuesto por Emile Chabal (investigador principal), Richard Hadden (diseñador web) y Anne Perez (investigadora postdoctoral). El equipo fue asistido por Keith McClelland, el autor de la primera bibliografía completa de los escritos de Eric Hobsbawm en 1982 que fue publicada en Raphael Samuel & Gareth Stedman Jones (eds.), Culture, Ideology and Politics: Essays for Eric Hobsbawm (Routledge, 1982). Keith revisó la bibliografía varias veces antes y después de la muerte de Hobsbawm en 2012. El equipo está extremadamente agradecido por su cooperación y generosidad sin lo cual esta nueva bibliografía no hubiera sido posible.</p><p> El desprendimiento del archivo de Eric Hobsbawm fue completado por archiveros en el Modern Records Center, University of Warwick. El equipo desea agradecer, en particular, a Elizabeth Wood quién proprocionó una copia de la base de datos del catálogo de archivos en un formato accesible.El equipo también quisiera agradecer la asistencia de Karen Howie para su ayuda en la preparación de la solicitud de subvención original y el equipo de Innovación Digital de la College of Arts, Humanities and Social Sciences de la University of Edinburgh por brindar apoyo logístico durante todo el proyecto.La base de datos de bibliografía y el catálogo de archivos son correctos a partir de mayo de 2020. El equipo se esforzará por procesar correcciones, adiciones y modificaciones tan pronto como se les notifique.</p><p>Para cualquier correspondencia relacionada con la bibliografía, incluidas consultas técnicas, envíe un correo electrónico a Emile Chabal (emile.chabal@ed.ac.uk). Para cualquier correspondencia relacionada con los archivos de Hobsbawm, comuníquese con el Modern Records Centre, University of Warwick.',
    },
    */
    'about_text': {
        DEBUG: 'lorem',
        EN:
            '<p>This website forms part of a research project entitled ' +
            '‘An Intellectual Biography of Eric Hobsbawm’, funded by the\n' +
            'United Kingdom Arts and Humanities Research Council under grant number AH/P008720/1. ' +
            'The grant was awarded\n' +
            'to Emile Chabal (University of Edinburgh) and ran from December 2017 to June 2020.</p>' +
            '\n\n<p>The website was built by a team composed of ' + 
            '<react:link href="https://emilechabal.com/">Emile Chabal</react:link>\n' +
            '(principal investigator), ' +
            '<react:link href="https://www.oeaw.ac.at/acdh/team/current-team/richard-hadden/">Richard Hadden</react:link> ' + 
            '(research technologist), and <react:link href="https://ucdavis.academia.edu/AnneMarino">Anne Perez</react:link> ' + 
            '(postdoctoral researcher). It was updated in 2024 by Ed MacKenzie.</p>\n\n' + 
            '<p>The team was assisted by Keith McClelland who compiled the first complete bibliography of ' +
            'Eric Hobsbawm’s writing in 1982,\n' + 
            'which was published in Raphael Samuel & Gareth Stedman Jones (eds.), ' + 
            '<em>Culture, Ideology and Politics: Essays for Eric Hobsbawm</em> (Routledge, 1982). ' + 
            'Keith revised the bibliography several times before and after Hobsbawm’s death in 2012. ' + 
            'The team are extremely grateful for his cooperation and generosity; without his efforts, ' + 
            'this online bibliography would not have been possible.</p>\n' + 
            '<p>The organisation and cataloguing of Eric Hobsbawm’s archive were completed by archivists at the Modern Records Centre, University of Warwick. The team wishes to thank, in particular, Elizabeth Wood for her help in providing a copy of the archival catalogue database in an accessible format.</p>\n' + 
            '<p>The team would also like to acknowledge the assistance of Karen Howie in helping to prepare the original grant application and the College of Arts, Humanities and Social Sciences Digital Innovation Team for providing logistical and technical support throughout the project.</p>\n' + 
            '<p>Note that the bibliography database and archive catalogue are correct as of July 2025. The team will endeavour to process corrections, additions and amendments as soon as they are notified of them.</p>\n' + 
            '<p>For any correspondence relating to the bibliography, including technical queries, please e-mail Emile Chabal <react:link href="mailto:emile.chabal@ed.ac.uk">(emile.chabal@ed.ac.uk)</react:link>. For any correspondence related to Hobsbawm’s archives, please contact the <react:link href="https://warwick.ac.uk/services/library/mrc/contact_details/">Modern Records Centre</react:link>.</p>\n',
        FR:
            '<p>Cette bibliographie fait partie d’un projet de recherche intitulé « An intellectual biography of Eric Hobsbawm », financé par le Arts and Humanities Research Council du Royaume-Uni sous le numéro de subvention AH/P008720/1. La financement a été décernée à Emile Chabal (University of Edinburgh) et s’est déroulée de décembre 2017 à juin 2020.</p>\n' +
            '<p>Le site a été construit par une équipe composée d’Emile Chabal (chercheur principal), Richard Hadden (concepteur web) et Anne Perez (chercheuse postdoctorale). Il a été mis à jour en 2024 par Ed MacKenzie.</p>\n' +
            '<p>L’équipe a été assistée par Keith McClelland, l’auteur de la première bibliographie complète des écrits d’Eric Hobsbawm en 1982 qui a été publiée dans Raphael Samuel & Gareth Stedman Jones (ed.), Culture, Ideology and Politics: Essays for Eric Hobsbawm (Routledge, 1982). Keith a révisé la bibliographie plusieurs fois avant et après la mort de Hobsbawm en 2012. L’équipe tient à le remercier vivement pour sa coopération et sa générosité, sans quoi cette bibliographie en ligne n’aurait pas été possible.</p>\n' +
            '<p>L’organisation et le dépouillement des archives d’Eric Hobsbawm a été fait par des archivistes du Modern Records Centre, University of Warwick. L’équipe tient à remercier en particulier Elizabeth Wood pour avoir fourni une copie de la base de données du catalogue d’archives dans un format accessible.</p>\n' +
            '<p>L’équipe tient également à remercier Karen Howie pour son aide dans la préparation de la demande de subvention originale et la College of Arts, Humanities and Social Sciences Digital Innovation Team pour son soutien logistique tout au long du projet. Veuillez noter que la base de données bibliographique et le catalogue d’archives ont été mis à jour en juillet 2025. L’équipe s’efforcera de traiter les corrections, ajouts et modifications dès qu’ils en seront informés.</p>\n' +
            '<p>Pour toute correspondance relative à la bibliographie, y compris les questions techniques, veuillez contacter Emile Chabal (<react:link href="mailto:emile.chabal@ed.ac.uk">emile.chabal@ed.ac.uk</react:link>). Pour toute correspondance relative aux archives de Hobsbawm, veuillez contacter le <react:link href="https://warwick.ac.uk/services/library/mrc/contact_details/">Modern Records Centre</react:link>.</p>',
        ES:
            '<p><p>Esta bibliografía forma parte de un proyecto de investigación titulado ‘An Intellectual Biography of Eric Hobsbawm’, financiado por el Arts and Humanities Research Council con el número de subvención AH/P008720/1. La subvención se otorgó a Emile Chabal (University of Edinburgh) y se ejecutó desde diciembre de 2017 hasta junio de 2020.</p>' + 
            '<p>El sitio web fue construido por un equipo compuesto por Emile Chabal (investigador principal), Richard Hadden (diseñador web) y Anne Perez (investigadora postdoctoral). Fue actualizado en 2024 por Ed MacKenzie.</p>' +
            '<p>El equipo fue asistido por Keith McClelland, el autor de la primera bibliografía completa de los escritos de Eric Hobsbawm en 1982 que fue publicada en Raphael Samuel & Gareth Stedman Jones (eds.), Culture, Ideology and Politics: Essays for Eric Hobsbawm (Routledge, 1982). Keith revisó la bibliografía varias veces antes y después de la muerte de Hobsbawm en 2012. El equipo está extremadamente agradecido por su cooperación y generosidad sin lo cual esta nueva bibliografía no hubiera sido posible.</p>' + 
            '<p>El desprendimiento del archivo de Eric Hobsbawm fue completado por archiveros en el Modern Records Center, University of Warwick. El equipo desea agradecer, en particular, a Elizabeth Wood quién proprocionó una copia de la base de datos del catálogo de archivos en un formato accesible.</p>' + 
            '<p>El equipo también quisiera agradecer la asistencia de Karen Howie para su ayuda en la preparación de la solicitud de subvención original y el equipo de Innovación Digital de la College of Arts, Humanities and Social Sciences de la University of Edinburgh por brindar apoyo logístico durante todo el proyecto.La base de datos de bibliografía y el catálogo de archivos son correctos a partir de mayo de 2020. El equipo se esforzará por procesar correcciones, adiciones y modificaciones tan pronto como se les notifique.</p>' + 
            '<p>Para cualquier correspondencia relacionada con la bibliografía, incluidas consultas técnicas, comuníquese con Emile Chabal (<react:link href="mailto:emile.chabal@ed.ac.uk">emile.chabal@ed.ac.uk</react:link>). Para cualquier correspondencia relacionada con los archivos de Hobsbawm, comuníquese con el <react:link href="https://warwick.ac.uk/services/library/mrc/contact_details/">Modern Records Centre, University of Warwick</react:link>.</p>',
    },
    'guide_h1': {
        DEBUG: '[guide_h1]',
        EN: 'Guide for Users',
        FR: "Mode d'emploi du site",
        ES: 'Guía del usuario',
    },
    'guide_text': {
        DEBUG: '[guide_text]',
        EN:
            '<p>The Eric Hobsbawm Bibliography contains over 3,000 entries, including details of every published book, journal article, book chapter, review, newspaper article and pamphlet he ever wrote.</p>\n' + 
            '<p>It also includes a complete listing of his unpublished work and his private papers, which are held at the <react:link href="https://mrc-catalogue.warwick.ac.uk/records/EJH">Modern Records Centre, University of Warwick</react:link>.</p>',
        FR:
            '<p>La Bibliographie d’Eric Hobsbawm contient plus de 3,000 entrées, dont les détails de tous les ouvrages, articles, critiques, et essais publiés au long de sa carrière. Elle comprend également une recension complète de ses travaux inédits et de ses archives, qui sont conservés au <react:link href="https://mrc-catalogue.warwick.ac.uk/records/EJH">Modern Records Centre, University of Warwick</react:link>.</p>\n' + 
            '<p>Pour des raisons de droit d’auteur, il n’est pas possible d’accéder aux textes et aux documents directement dans la bibliographie. Cependant la majorité des entrées contient des liens directs vers des plates-formes externes telles que JSTOR ou Worldcat. Celles-ci peuvent être utilisés pour lire un texte original dans son intégralité ou localiser un ouvrage dans une bibliothèque à proximité.</p>\n' + 
            '<p>Nous vous proposons deux moyens de parcourir la bibliographie : soit en lançant une recherche dans l’ensemble de la base de données en utilisant le champ de recherche ; soit en parcourant les 20 listes thématiques spécialement conçues pour présenter certains aspects de la vie et de l’œuvre de Hobsbawm.</p>',
        ES:
            '<p>La bibliografía de Eric Hobsbawm contiene más de 3.000 entradas, incluidos detalles de todas las obras, artículos, reseñas y ensayos publicados a lo largo de su carrera. También incluye una revisión completa de su trabajo inédito y sus archivos personales, que se guardan en el <react:link href="https://mrc-catalogue.warwick.ac.uk/records/EJH">Modern Records Centre, University of Warwick</react:link>.</p>\n' +
            '<p>Por razones de derechos de autor, no es posible acceder a textos y documentos directamente en la bibliografía. Sin embargo, la mayoría de las entradas contienen enlaces directos a plataformas externas como JSTOR o Worldcat. Estos se pueden usar para leer un texto original en su totalidad o localizar una obra en una biblioteca cercana.</p>\n' +
            '<p>Hay dos formas de explorar la bibliografía: se puede buscar en toda la base de datos utilizando el campo de búsqueda o navegar por 20 listas temáticas especialmente diseñadas para presentar ciertos aspectos de la vida y el trabajo de Hobsbawm.</p>',
    },
    'data_encoding_h1': {
        DEBUG: '[data_encoding_h1]',
        EN: 'Data encoding',
        FR: 'Codage des données',
        ES: 'Codificación de datos',
    },
    'data_encoding_text': {
        DEBUG: '[data_encoding_text]',
        EN: `<p>Data in the Hobsbawm Bibliography is encoded 
                in XML using the Text Encoding Initiative (TEI) guidelines. 
                Data may be made available for researchers on request.
            </p>
            <p>Individual bibliographic items consist of a 
            <react:link
            href="https://tei-c.org/release/doc/tei-p5-doc/en/html/ref-biblStruct.html"
                    >
                        <code>&lt;tei:biblStruct&gt;</code>
                    </react:link> element containing 
                structured a bibliographic entry. Each entry has a unique 
                <code>@xml:id</code>.</p>
            <p>Pointer elements (<code>&lt;tei:ptr&gt;</code>) are used to encode 
                relations between bibliographic items (as in the case of new 
                editions or translations). Pointers are always directed from the ‘derivative’ 
                item to its source (i.e. a translation points to the original; 
                a second edition points back to the first edition).
            </p>
            <p>Archive materials are encoded using nested <code>&lt;tei:bibl&gt;</code> elements 
            that replicate the structure of the archival material held at the 
            University of Warwick.</p>
            
            <p>The website is built using <react:link href="http://exist-db.org/exist/apps/homepage/index.html">eXist-DB</react:link>, with a React-JS frontend.</p>`,
        FR: `<p>Les données de la bibliographie Hobsbawm sont codées
             en XML en utilisant les directives TEI (Text Encoding Initiative). 
             Les données peuvent être mises à la disposition des chercheurs sur demande.</p>
             <p>Les éléments bibliographiques individuels se composent 
             d'un élément <react:link
             href="https://tei-c.org/release/doc/tei-p5-doc/en/html/ref-biblStruct.html"
         >
             <code>&lt;tei:biblStruct&gt;</code>
         </react:link> contenant une entrée bibliographique structurée.
          Chaque entrée a un <code>@xml:id</code> unique.
          </p>
          
          <p>Les éléments pointeurs (<code>&lt;tei:ptr&gt;</code>) sont utilisés pour 
          coder les relations entre les éléments bibliographiques 
          (comme dans le cas des nouvelles éditions ou des traductions). 
          Les pointeurs sont toujours dirigés de l'élément «dérivé» vers sa source 
          (c'est-à-dire qu'une traduction pointe vers l'original; 
          une deuxième édition renvoie à la première édition).</p>
          <p>Les documents d'archives sont codés à l'aide d'éléments 
            <code>&lt;tei:bibl&gt;</code> imbriqués qui reproduire 
            la structure du matériel d'archives conservé à l'Université de Warwick.</p>
            <p>Le site Web est construit à l'aide d'<react:link href="http://exist-db.org/exist/apps/homepage/index.html">eXist-DB</react:link>, avec une interface React-JS.</p>`,
        ES: `<p>
                Los datos de la bibliografía de Hobsbawm están 
                codificados en XML utilizando las pautas 
                de la Iniciativa de codificación de texto (TEI). 
                Los datos pueden estar disponibles para los investigadores que lo soliciten.</p> 
                
            <p>Los elementos bibliográficos individuales consisten 
            en un elemento <react:link
            href="https://tei-c.org/release/doc/tei-p5-doc/en/html/ref-biblStruct.html"
        >
            <code>&lt;tei:biblStruct&gt;</code>
        </react:link> que contiene una entrada bibliográfica estructurada. 
        Cada entrada tiene un <code>@xml:id</code> único.</p>
        
        <p>Los elementos de puntero (<code>&lt;tei:ptr&gt;</code>) se utilizan 
        para codificar relaciones entre elementos bibliográficos 
        (como en el caso de nuevas ediciones o traducciones). 
        Los indicadores siempre se dirigen desde el elemento 
        'derivado' a su fuente (es decir, una traducción apunta al original; 
            una segunda edición apunta hacia la primera edición).</p>
            
            <p>Los materiales de archivo se codifican utilizando elementos <code>&lt;tei:bibl&gt;</code> 
            anidados replicar la estructura del material de archivo que se encuentra en la Universidad de Warwick.</p>
            
            <p>El sitio web está construido usando <react:link href="http://exist-db.org/exist/apps/homepage/index.html">eXist-DB</react:link>, con una interfaz React-JS.</p>`,
    },
    'biography_text': {
        DEBUG: 'lorem',
        EN: `<p>Eric Hobsbawm was one of the leading Marxist historians 
                of the twentieth century and one of the best-known \n 
                       historians in the English-speaking world.</p>\n\n 
               
            <p>Hobsbawm was born in Alexandria, Egypt in 1917 and spent his 
                childhood in Vienna and Berlin. Following the death \n        
                of his parents and Hitler’s rise to power, he moved to London in 
                1933. He continued his studies at St Marylebone’s \n        
                Grammar School in London, before gaining a scholarship to 
                King’s College, Cambridge where he matriculated in 1936. \n 
                He graduated in 1939. During the Second World War, he was based in 
                England and served principally in the Army Educational Corps.</p>\n\n  
                After the war, Hobsbawm returned at Cambridge for his doctoral 
                research (1945-9) and was subsequently elected to a fellowship at 
                King’s.\n         
                In 1947, he was given a lectureship at Birkbeck College, 
                University of London. He remained at Birkbeck for his entire career \n         
                until his retirement in 1982, after which he held a yearly one-semester 
                visiting position at the New School of Social Research\n          
                in New York from 1984 until 1997. He was elected president of 
                Birkbeck in 2002.</p>\n\n        
                
            <p>Hobsbawm made his name as a member of the 
                Communist Party Historians Group in the late 1940s and early 1950s. During this 
                period, \n        he worked on different aspects of British labour and
                economic history and made influential interventions in 
                various historiographical \n        debates on the “standard of 
                living” and the “transition” from feudalism to capitalism. 
                He was also employed as a critic for the <em>New     
                Statesman</em> magazine, writing a series of articles and reviews about jazz and popular 
                music under the pseudonym <react:link href="/person/hobsbawm-newton">Francis Newton</react:link>.</p>\n\n        
            
            <p>From the late 1950s until the 1980s, he devoted a good deal of his research to the 
                question of “primitive” rebellion, banditry, \n        
                peasant political movements, and the structure of agrarian societies, 
                both inside and outside Europe. His interest in these topics \n       
                was sparked by his travels to Italy and Spain in the 1950s, then to Latin America 
                in the 1960s and 1970s. This led to the publication \n        
                of various sets of essays, the most influential of which was 
                <react:link href="/bibl/primitive-rebels">Primitive Rebels (1959)</react:link>.</p>\n\n     
        
            <p>Hobsbawm is perhaps best-known for his trilogy of introductory
                textbooks about the “long 19th century” &mdash; 
                <react:link href="/bibl/the-age-of-revolution">The Age of \n        
                Revolution: Europe 1789–1848 (1962)</react:link>, 
                <react:link href="/bibl/the-age-of-capital-1848-1875">The Age of Capital: 1848–1875 (1975)</react:link> 
                and <react:link href="/bibl/the-age-of-empire-1875-1914">The Age of Empire: 1875–1914 (1987)</react:link> 
                &mdash; and his overview of the 20th century, 
                <react:link href="/bibl/age-of-extremes">The Age of Extremes: The Short Twentieth Century, 1914-1991 (1994)</react:link>. 
                These books sold \n        hundreds of thousands of copies and were 
                translated into many languages. In countries such as Brazil, they made him a household name.</p>
                
            <p>In his later years, Hobsbawm published on an extraordinary 
                range of topics, including nations and nationalism, 
                “invented traditions”, globalisation, and terrorism. 
                He also became a prominent public intellectual who was embroiled 
                in a series of debates about the future of the left in the UK and elsewhere 
                in the 1980s and 1990s. In 2003, Hobsbawm \n        
                received the Balzan Prize for European History since 
                1900 “for his brilliant analysis of the troubled history of 20th century Europe and for 
                his ability to combine in-depth historical research with great literary talent.” 
                Shortly before he died, he republished some of his essays on Marx and Marxism 
                in response to a renewed interest in Marxist ideas following the financial crisis of 2008.</p>
                
            <p>Hobsbawm was a life-long Communist. He identified with the 
            communist movement during his teenage years in Berlin, but only formally joined the Communist 
            Party of Great Britain (CPGB) in 1936, upon arrival at Cambridge. He remained 
            a party member until the CPGB was dissolved in 1991. After the crisis of 1956, 
            he became increasingly detached from British communism, but he developed a 
            strong association with the Partito Comunista Italiano (PCI) until \n       
             it, too, fell apart in 1991. Although his communist leanings were clearly 
             visible in many of his writings, he was neither dogmatic nor beholden to specific 
             Marxist interpretations of history. However, he was unrepentant about his 
             communist views, and his political commitment profoundly 
             shaped both his social and \n        intellectual life.</p>
             
             <p>Hobsbawm died in 2012 at the age of 95.</p>\n       
              <react:align-right><em>― Emile Chabal (2020)</em></react:align-right>\n        
              
              <br/>\n        <br/>\n        
              <p><em>For more detailed biographical information, 
              see Eric Hobsbawm’s entry in the 
              <react:link href="https://doi.org/10.1093/ref:odnb/105680">Oxford Dictionary of National Biography (2016)</react:link> 
              and his <react:link href="https://www.thebritishacademy.ac.uk/sites/default/files/10 Hobsbawn 1820.pdf">British Academy obituary (2015)</react:link>. 
              Additional critical perspectives on Hobsbawm’s life and work can be found in this
             bibliography in the section entitled 
             <react:link href="/category/appraising-hobsbawm">‘Appraising Hobsbawm’</react:link>.</em></p>`,
        FR:
            '<p>Eric Hobsbawm est l’un des principaux historiens marxistes du XXe siècle et \n        l’un des historiens les plus connus du monde anglophone.</p>\n\n        <p>Hobsbawm naît à Alexandrie, en Égypte, en 1917, et passe son enfance à Vienne et à Berlin. \n        Après la mort de ses parents et la montée au pouvoir d’Hitler, il s’installe \n        à Londres en 1933. Il poursuit ses études à St Marylebone’s Grammar School \n        à Londres, avant d’obtenir une bourse à King’s College, Cambridge où il s’inscrit en \n        1936. Il est diplômé en 1939. Pendant la Seconde Guerre mondiale, il est basé en Angleterre et sert \n        principalement dans le Army Educational Corps.</p>\n\n        Après la guerre, Hobsbawm revient à Cambridge pour ses recherches doctorales (1945-1949) et devient \n        ensuite <em>fellow</em> de King’s. En 1947, il décroche un poste de maître de conférences au Birkbeck College \n        de l’Université de Londres. Il restera à Birkbeck pendant toute sa carrière jusqu’à sa retraite en 1982, \n        avant d’occuper un poste de <em>visiting professor</em> à la New School of Social Research de New York de 1984 à 1997. \n        Il est élu président de Birkbeck en 2002.</p>\n\n        <p>Hobsbawm se fait remarquer comme membre brillant du Communist Party Historians Group à \n        la fin des années 40 et au début des années 50. Pendant cette période, il fait des recherches \n        sur différents aspects de l’histoire du travail et de l’économie britannique et intervient notamment \n        dans divers débats historiographiques sur le « niveau de vie » et la « transition » du féodalisme au \n        capitalisme. En même temps, il est embauché par le magazine <em>New Statesman</em>, pour lequel il écrit une \n        série d’articles sur le jazz et la musique populaire sous le pseudonyme de <react:link href="/person/hobsbawm-newton">Francis Newton</react:link>.</p>\n\n        <p>De la fin des années 50 aux années 80, il consacre une grande partie de ses recherches à la \n        question de la rébellion « primitive », au banditisme, aux mouvements politiques paysans et à la \n        structure des sociétés agraires européennes et mondiales. Son intérêt pour ces sujets est déclenché \n        par ses voyages en Italie et en Espagne dans les années 50, puis en Amérique latine dans les années \n        60 et 70. Cela conduit à la publication de divers recueils d’essais et d’articles, dont le plus influent \n        est <react:link href="/bibl/primitive-rebels">Primitive Rebels (1959)</react:link>.</p>\n        \n        <p>Hobsbawm est peut-être mieux connu pour sa trilogie de textes de vulgarisation historique sur \n        le XIXe siècle &mdash; <react:link href="/bibl/the-age-of-revolution">The Age of \n        Revolution: Europe 1789–1848 (1962)</react:link>, <react:link href="/bibl/the-age-of-capital-1848-1875">The Age of Capital: 1848–1875 (1975)</react:link> et \n        <react:link href="/bibl/the-age-of-empire-1875-1914">The Age of Empire: 1875–1914 (1987)</react:link> &mdash; et son aperçu du XXe siècle, <react:link href="/bibl/age-of-extremes">The Age of Extremes: The Short Twentieth Century, 1914-1991 (1994)</react:link>. Ces livres se vendent à des centaines de milliers d’exemplaires et \n        sont traduits dans de nombreuses langues. Il doit sa renommée internationale à cette série de livres \n        conçu pour le grand public.</p>\n\n        <p>Vers la fin de sa carrière, Hobsbawm développe des analyses sur des sujets très divers tels \n        que les nations et le nationalisme, les « traditions inventées », la mondialisation et le terrorisme. \n        Il devient également un intellectuel public et s’engage dans une série de débats sur l’avenir \n        de la gauche en Europe dans les années 80 et 90. En 2003, il reçoit le Prix Balzan d’histoire \n        européenne depuis 1900 « pour sa brillante analyse de l’histoire troublée de l’Europe du XXe \n        siècle et pour sa capacité à combiner une recherche historique approfondie avec un grand talent \n        littéraire. » Peu de temps avant sa mort, il republie certains de ses essais sur Marx et le marxisme \n        à la suite du regain d’intérêt pour les idées marxistes après la crise financière de 2008.</p>\n        \n        <p>Hobsbawm reste de conviction communiste toute sa vie. Il s’identifie au mouvement \n        communiste dès son adolescence à Berlin, mais ne rejoint officiellement le Parti communiste \n        de Grande-Bretagne (CPGB) qu’en 1936, à son arrivée à Cambridge. Il reste membre du parti \n        jusqu’à la dissolution du CPGB en 1991. Après la crise de 1956, il se détache de plus en \n        plus du communisme britannique, mais il développe en contrepartie une forte association avec \n        le Partito Comunista Italiano (PCI) jusqu’à ce que celui-ci s’effondre également en 1991. Bien \n        que ses tendances communistes soient clairement visibles dans bon nombre de ses écrits, il n’est ni \n        dogmatique ni rattaché à une interprétation strictement marxiste de l’histoire. Cependant, il ne \n        renonce jamais à son engagement communiste qui façonne profondément sa vie sociale et intellectuelle.</p>\n\n        <p>Hobsbawm meurt en 2012 à l’âge de 95 ans.</p>\n        <react:align-right><em>― Emile Chabal (2020)</em></react:align-right>\n        <br/>\n        <br/>\n        <p><em>Pour des informations biographiques plus amples, voir la fiche sur Eric Hobsbawm dans le <react:link href="https://doi.org/10.1093/ref:odnb/105680">Oxford Dictionary \n        of National Biography (2016)</react:link> et sa <react:link href="https://www.thebritishacademy.ac.uk/sites/default/files/10 Hobsbawn 1820.pdf">nécrologie sur le site web de la British Academy (2015)</react:link>. Il est également \n        possible d’accéder à des nombreux textes sur la vie et l\'œuvre de Hobsbawm dans cette bibliographie dans la \n        rubrique intitulée <react:link href="/category/appraising-hobsbawm">« Perspectives critiques sur Hobsbawm »</react:link>.</em></p>\n        ',
        ES: `<p>Eric Hobsbawm era uno de los principales historiadores 
        marxistas del siglo XX y uno de los historiadores más conocidos del mundo anglófono.</p>
        
        <p> Hobsbawm nació en Alejandría, Egipto, en 1917, y pasó su infancia en Viena y Berlín. 
        Tras la muerte de sus padres y el ascenso al poder de Hitler, se mudó a Londres en 1933. 
        Continuó sus estudios en la St Marylebone Grammar School en Londres, antes de obtener una 
        beca para el King’s College, Cambridge, donde se matriculó en 1936. Se graduó en 1939. 
        Durante la Segunda Guerra Mundial, se quedó en Inglaterra y sirvió principalmente en el 
        Army Educational Corps.</p><p> Después de la guerra, Hobsbawm regresó a Cambridge para 
        sus estudios doctorales (1945-9) y posteriormente fue nombrado a un fellowship en King’s. 
        En 1947, obtuvo un lectorado en el Birkbeck College de la Universidad de Londres. 
        Permaneció en Birkbeck durante toda su carrera hasta su jubilación en 1982, después 
        de lo cual ocupó un visiting professorship en la New School of Social Research en Nueva 
        York desde 1984 hasta 1997. Fue elegido presidente de Birkbeck en 2002.</p>
        
        <p> Hobsbawm era miembro del Communist Party Historians Group a fines de la década 
        de 1940 y principios de la de 1950 y pronto se ganó una reputación como historiador 
        brillante. Durante este período, trabajó en diferentes aspectos de la historia 
        del mundo obrero británico y la historia económica. Hizo intervenciones 
        influyentes en varios debates historiográficos sobre el “nivel de vida” y 
        la “transición” del feudalismo al capitalismo. También fue contratado por 
        la revista <em>New Statesman</em>, escribiendo una serie de artículos y 
        reseñas sobre jazz y música popular bajo el seudónimo de <react:link href="/person/hobsbawm-newton">Francis Newton</react:link>.</p>
        
        <p>Desde finales de la década de 1950 hasta la década de 1980, 
        dedicó buena parte de sus investigaciones a la 
        rebelión “primitiva”, el bandolerismo, los movimientos 
        políticos campesinos y la estructura de las sociedades agrarias, 
        tanto dentro como fuera de Europa. El interés de Hobsbawm en estos 
        temas fue provocado por sus viajes a Italia y España en la década de 1950, 
        luego a América Latina en las décadas de 1960 y 1970. Esto condujo a la 
        publicación de varios conjuntos de ensayos, el más influyente de 
        los cuales fue <react:link href="/bibl/primitive-rebels">Primitive Rebels (1959)</react:link>. </p>
        
        <p>Hobsbawm es quizás mejor conocido por su trilogía de libros sobre 
        el “largo siglo XIX” – <react:link href="/bibl/the-age-of-revolution">The Age of \n        
        Revolution: Europe 1789–1848 (1962)</react:link>, 
        <react:link href="/bibl/the-age-of-capital-1848-1875">The Age of Capital: 1848–1875 (1975)</react:link> y <react:link href="/bibl/the-age-of-empire-1875-1914">The Age of Empire: 1875–1914 (1987)</react:link> 
        – y su sintésis de la historia del siglo XX, 
        <react:link href="/bibl/age-of-extremes">The Age of Extremes: The Short Twentieth Century, 1914-1991 (1994)</react:link>. 
        Estos libros vendieron cientos de miles de copias y fueron traducidos a muchos idiomas. 
        Debe su fama internacional a esta serie de libros diseñados para un 
        público instruido pero no académico.</p>
        
        <p>En sus últimos años, Hobsbawm publicó sobre una impresionante 
        gama de temas, incluso las naciones y el nacionalismo, 
        las “tradiciones inventadas”, la globalización y el terrorismo. 
        También se convirtió en un destacado intelectual público y participó 
        en una serie de debates sobre el futuro de la izquierda europea en los 
        años 80 y 90. En 2003, Hobsbawm recibió el Premio Balzan de Historia 
        Europea desde 1900 “por su brillante análisis de la turbulenta historia 
        de la Europa del siglo XX y por su capacidad de combinar una 
        investigación histórica en profundidad con un gran talento literario”. 
        Poco antes de morir, volvió a publicar algunos de sus ensayos sobre 
        Marx y el marxismo en respuesta a un renovado interés en las ideas 
        marxistas tras la crisis financiera de 2008. </p>
        
        <p>Hobsbawm fue comunista toda su vida. Se identificó con el 
        movimiento comunista ya durante su adolescencia en Berlín, 
        pero solo se unió formalmente al Partido Comunista de Gran Bretaña (CPGB) 
        en 1936, a su llegada a Cambridge. Siguió siendo miembro del partido hasta 
        que el CPGB se disolvió en 1991. Después de la crisis de 1956, se separó 
        cada vez más del comunismo británico, pero desarrolló una fuerte 
        asociación con el Partito Comunista Italiano (PCI) hasta que éste 
        también se derrumbó en 1991. Aunque sus inclinaciones comunistas 
        eran claramente visibles en muchos de sus escritos, no era dogmático 
        ni se adhirió a una sola interpretación marxista de la historia. 
        Sin embargo, no se arrepintió de sus convicciones comunistas, 
        y su compromiso político moldeó profundamente su vida social e intelectual. </p>
        
        <react:align-right><em>― Emile Chabal (2020)</em></react:align-right>\n        
              
              <br/>\n        <br/>
        
        <p><em>Para información biográfica más detallada, consulte la entrada sobre 
        Eric Hobsbawm en el <react:link href="https://doi.org/10.1093/ref:odnb/105680">Oxford Dictionary of National Biography (2016)</react:link> y su 
        <react:link href="https://www.thebritishacademy.ac.uk/sites/default/files/10 Hobsbawn 1820.pdf">obituario en el sitio web del British Academy (2015)</react:link>. Se pueden encontrar 
        más perspectivas sobre su vida y su trabajo en esta bibliografía en la 
        categoría titulada <react:link href="/category/appraising-hobsbawm">« Perspectivas críticas sobre Hobsbawm »</react:link>.</em><p>`,
    },
    'search_box_label': {
        DEBUG: '[search_box_label]',
        EN: 'Search',
        FR: 'Cherchez',
        ES: 'Buscar',
    },
    'explore_the_bibliography_button': {
        DEBUG: '[explore_the_bibliography_button]',
        EN: 'Explore the bibliography',
        FR: 'Explorez la bibliographie',
        ES: 'Explorar la bibliografia',
    },
    'test': {
        DEBUG: '[TEST]',
        EN: 'Testing testing one two three',
        FR: 'En faisant le test, un deux etc.',
        ES: 'Test, uno, dos, tres',
    },
    'categories': {
        DEBUG: '[categories]',
        EN: 'Categories',
        FR: 'Catégories',
        ES: 'Categorías',
    },
    'spanish': {
        DEBUG: '[spanish]',
        EN: 'Spanish',
        FR: 'Espagnol',
        ES: 'Castellano',
    },
    'french': {
        DEBUG: '[french]',
        EN: 'French',
        FR: 'Français',
        ES: 'Francés',
    },
    'italian': {
        DEBUG: '[italian]',
        EN: 'Italian',
        FR: 'Italien',
        ES: 'Italiano',
    },
    'worldcat_entry': {
        DEBUG: '[worldcat_entry]',
        EN: 'WorldCat entry',
        FR: 'Entrée dans WorldCat',
        ES: 'Entrada en Worldcat',
    },
    'translation': {
        DEBUG: '[translation]',
        EN: 'translation',
        FR: 'traduction',
        ES: 'traducción',
    },
    'translation_plural': {
        DEBUG: '[translation_plural]',
        EN: 'translations',
        FR: 'traductions',
        ES: 'traducciones',
    },
    'lorem': {
        DEBUG:
            'Lorem ipsum dolor amet gochujang enamel pin typewriter hell of, aesthetic PBR&B DIY banjo readymade quinoa man bun plaid polaroid sriracha. Crucifix church-key shoreditch bushwick quinoa art party. Freegan intelligentsia mixtape, forage offal cold-pressed schlitz cardigan franzen williamsburg letterpress pop-up farm-to-table. Mlkshk slow-carb bitters aesthetic bespoke mixtape pour-over unicorn prism chambray. XOXO leggings try-hard, raw denim viral direct trade master cleanse activated charcoal selfies venmo jean shorts meh. Readymade small batch pinterest cornhole photo booth snackwave marfa health goth flannel yr.',
        EN:
            'Lorem ipsum dolor amet gochujang enamel pin typewriter hell of, aesthetic PBR&B DIY banjo readymade quinoa man bun plaid polaroid sriracha. Crucifix church-key shoreditch bushwick quinoa art party. Freegan intelligentsia mixtape, forage offal cold-pressed schlitz cardigan franzen williamsburg letterpress pop-up farm-to-table. Mlkshk slow-carb bitters aesthetic bespoke mixtape pour-over unicorn prism chambray. XOXO leggings try-hard, raw denim viral direct trade master cleanse activated charcoal selfies venmo jean shorts meh. Readymade small batch pinterest cornhole photo booth snackwave marfa health goth flannel yr.',
        FR:
            'Lorem superposés valise pourparlers rêver chiots rendez-vous naissance Eiffel myrtille. Grèves Arc de Triomphe encore pourquoi sentiments baguette pédiluve une projet sentiments saperlipopette vachement le. Brume éphémère baguette Bordeaux en fait sommet avoir minitel. Nous avoir parole la nous moussant. Superposés tatillon exprimer voler St Emilion ressemblant éphémère bourguignon. Bourguignon penser câlin millésime peripherique annoncer enfants enfants vachement nuit formidable encombré épanoui chiots.',
        ES:
            'Lorem castellano Lorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellanoLorem castellano.',
    },
    'journal-article': {
        DEBUG: '[journal-article]',
        EN: 'Journal Article',
        FR: 'Article dans une revue',
        ES: 'Artículo en una revista',
    },
    'journal-article_plural': {
        DEBUG: '[journal-article_plural]',
        EN: 'Journal Articles',
        FR: 'Articles dans une revue',
        ES: 'Artículos en una revista',
    },
    'newspaper-article': {
        DEBUG: '[newspaper-article]',
        EN: 'Newspaper Article',
        FR: 'Article dans un journal',
        ES: 'Artículo en un periódico',
    },
    'newspaper-article_plural': {
        DEBUG: '[newspaper-article_plural]',
        EN: 'Newspaper Articles',
        FR: 'Articles dans un journal',
        ES: 'Artículos en un periódico',
    },
    'PhD-thesis': {
        DEBUG: '[PhD-thesis]',
        EN: 'PhD Thesis',
        FR: 'Thèse de doctorat',
        ES: 'Tesis doctoral',
    },
    'book': {
        DEBUG: '[book]',
        EN: 'Book',
        FR: 'Livre',
        ES: 'Libro',
    },
    'book_plural': {
        DEBUG: '[book_plural]',
        EN: 'Books',
        FR: 'Livres',
        ES: 'Libros',
    },
    'book-chapter': {
        DEBUG: '[book-chapter]',
        EN: 'Book Chapter',
        FR: 'Chapitre dans une livre',
        ES: 'Capítulo en un libro',
    },
    'book-chapter_plural': {
        DEBUG: '[book-chapter_plural]',
        EN: 'Book Chapters',
        FR: 'Chapitres dans une livre',
        ES: 'Capítulos en un libro',
    },
    'pamphlet': {
        DEBUG: '[pamphlet]',
        EN: 'Pamphlet',
        FR: 'Brochure',
        ES: 'Folleto',
    },
    'pamphlet_plural': {
        DEBUG: '[pamphlet_plural]',
        EN: 'Pamphlets',
        FR: 'Brochures',
        ES: 'Folletos',
    },
    'book-review': {
        DEBUG: '[book-review]',
        EN: 'Book Review',
        FR: 'Critique de livre',
        ES: 'Reseña de libro',
    },
    'book-review_plural': {
        DEBUG: '[book-review_plural]',
        EN: 'Book Reviews',
        FR: 'Critiques de livre',
        ES: 'Reseñas de libro',
    },
    'interview': {
        DEBUG: '[interview]',
        EN: 'Interview',
        FR: 'Entretien',
        ES: 'Entrevista',
    },
    'interview_plural': {
        DEBUG: '[interview_plural]',
        EN: 'Interviews',
        FR: 'Entretiens',
        ES: 'Entrevistas',
    },
    'interview-with': {
        DEBUG: '[interview-with]',
        EN: 'Interview',
        FR: 'Entretien',
        ES: 'Entrevista',
    },
    'interview-with_plural': {
        DEBUG: '[interview-with_plural]',
        EN: 'Interviews',
        FR: 'Entretiens',
        ES: 'Entrevista',
    },
    'lecture': {
        DEBUG: '[lecture]',
        EN: 'Lecture',
        FR: 'Conférence',
        ES: 'Conferencia',
    },
    'lecture_plural': {
        DEBUG: '[lecture_plural]',
        EN: 'Lectures',
        FR: 'Conférences',
        ES: 'Conferencias',
    },
    'feature': {
        DEBUG: '[feature]',
        EN: 'Feature',
        FR: 'Reportage',
        ES: 'Reportaje',
    },
    'feature_plural': {
        DEBUG: '[feature_plural]',
        EN: 'Features',
        FR: 'Reportages',
        ES: 'Reportajes',
    },
    'talks': {
        DEBUG: '[talks]',
        EN: 'Talk',
        FR: 'Conférence',
        ES: 'Conferencia',
    },
    'talks_plural': {
        DEBUG: '[talks_plural]',
        EN: 'Talks',
        FR: 'Conférences',
        ES: 'Conferencias',
    },
    'comment': {
        DEBUG: '[comment]',
        EN: 'Comment',
        FR: 'Commentaire',
        ES: 'Comentario',
    },

    'comment_plural': {
        DEBUG: '[comment_plural]',
        EN: 'Comment',
        FR: 'Commentaires',
        ES: 'Comentarios',
    },

    'archive': {
        DEBUG: '[archive]',
        EN: 'Archive',
        FR: 'Archive',
        ES: 'Archivo',
    },
    'archive_plural': {
        DEBUG: '[archive_plural]',
        EN: 'Archives',
        FR: 'Archives',
        ES: 'Archivos',
    },
    'review': {
        DEBUG: '[review]',
        EN: 'Review',
        FR: 'Critique',
        ES: 'Reseña',
    },
    'review_plural': {
        DEBUG: '[review_plural]',
        EN: 'Reviews',
        FR: 'Critiques',
        ES: 'Reseñas',
    },
    'edited-volume': {
        DEBUG: '[edited-volume]',
        EN: 'Edited volume',
        FR: 'Ouvrage collectif',
        ES: 'Trabajo colectivo',
    },
    'person': {
        DEBUG: '[person]',
        EN: 'Person',
        FR: 'Personne',
        ES: 'Persona',
    },
    'category': {
        DEBUG: '[category]',
        EN: 'Category',
        FR: 'Catégorie',
        ES: 'Categoría',
    },
    'named-container-type-contents': {
        DEBUG: '[contents]',
        EN: 'Contents',
        FR: 'Contenu',
        ES: 'Contenido',
    },
    'named-container-type-journal': {
        DEBUG: '[named-container-type-journal]',
        EN: 'Journal',
        FR: 'Revue',
        ES: 'Revista',
    },
    'named-container-type-edited-volume': {
        DEBUG: '[named-container-type-edited-volume]',
        EN: 'Edited volume',
        FR: 'Ouvrage collectif',
        ES: 'Trabajo colectivo',
    },
    'named-container-type-newspaper': {
        DEBUG: '[named-container-type-newspaper]',
        EN: 'Newspaper',
        FR: 'Journal',
        ES: 'Periódico',
    },
    'named-container-type-tv-broadcast': {
        DEBUG: '[named-container-type-tv-broadcast]',
        EN: 'TV Broadcast',
        FR: 'Diffusion télévisée',
        ES: 'Transmisión Televisiva',       
    },
    'named-container-type-PhD-thesis': {
        DEBUG: '[named-container-type-PhD-thesis]',
        EN: 'PhD Thesis',
        FR: 'Thèse de doctorat',
        ES: 'Tesis doctoral',
    },
    'named-container-type-book': {
        DEBUG: '[named-container-type-book]',
        EN: 'Book',
        FR: 'Book',
        ES: 'Libro',
    },
    'named-container-type-book-reviewed': {
        DEBUG: '[named-container-type-book-reviewed]',
        EN: 'Book Reviewed',
        FR: 'Livre recensé',
        ES: 'Libro reseñado',
    },
    'named-container-type-notes': {
        DEBUG: '[named-container-type-notes]',
        EN: 'Notes',
        FR: 'Notes',
        ES: 'Notas',
    },
    'named-container-type-pamphlet': {
        DEBUG: '[named-container-type-pamphlet]',
        EN: 'Pamphlet',
        FR: 'Pamphlet',
        ES: 'Folleto',
    },
    'named-container-type-alternative-editions': {
        DEBUG: '[named-container-type-alternative-editions]',
        EN: 'Alternative Editions',
        FR: 'Editions alternatives',
        ES: 'Ediciones alternativas',
    },
    'named-container-type-reprinted-chapter': {
        DEBUG: '[named-container-type-reprinted-chapter]',
        EN: 'Reprinted  chapter',
        FR: 'Chapitre réimprimé',
        ES: 'Capítulo republicado',
    },
    'tv-title-part': {
        DEBUG: '[tv-title-part]',
        EN: 'Part',
        FR: 'Partie',
        ES: 'Parte',
    },
    'tv-title-author': {
        DEBUG: '[tv-title-author]',
        EN: 'Author',
        FR: 'Auteur',
        ES: 'Autor',
    },
    'tv-title-author_singular': {
        DEBUG: '[tv-title-author_singular]',
        EN: 'Author',
        FR: 'Auteur',
        ES: 'Autor',
    },
    'tv-title-author_plural': {
        DEBUG: '[tv-title-author_plural]',
        EN: 'Authors',
        FR: 'Auteurs',
        ES: 'Autores',
    },
    'tv-title-editor_singular': {
        DEBUG: '[tv-title-editor_singular]',
        EN: 'Editor',
        FR: 'Editeur',
        ES: 'Editor',
    },
    'tv-title-editor_plural': {
        DEBUG: '[tv-title-editor_plural]',
        EN: 'Editors',
        FR: 'Editeurs',
        ES: 'Editores',
    },
    'tv-title-title': {
        DEBUG: '[tv-title-title]',
        EN: 'Title',
        FR: 'Titre',
        ES: 'Título',
    },
    'tv-title-organiser_singular': {
        DEBUG: '[tv-title-organiser_singular]',
        EN: 'Organiser',
        FR: 'Organisateur',
        ES: 'Organizador',
    },
    'tv-title-organiser_plural': {
        DEBUG: '[tv-title-organiser_plural]',
        EN: 'Organisers',
        FR: 'Organisateurs',
        ES: 'Organizadores',
    },
    'tv-title-broadcaster_singular': {
        DEBUG: '[tv-title-broadcaster_singular]',
        EN: 'Broadcaster',
        FR: 'Chaine de télévision ou de radio',
        ES: 'Canal de televisión o radio',
    },
    'tv-title-broadcaster_plural': {
        DEBUG: '[tv-title-broadcaster_plural]',
        EN: 'Broadcasters',
        FR: 'Chaines de télévision ou de radio',
        ES: 'Canales de televisión o radio',
    },
    'tv-title-contributor_singular': {
        DEBUG: '[tv-title-contributor_singular]',
        EN: 'Contributor',
        FR: 'Participant',
        ES: 'Colaborador',
    },
    'tv-title-contributor_plural': {
        DEBUG: '[tv-title-contributor_plural]',
        EN: 'Contributors',
        FR: 'Participants',
        ES: 'Colaboradores',
    },
    'tv-title-place': {
        DEBUG: '[tv-title-place]',
        EN: 'Place',
        FR: "Lieu d'enregistrement",
        ES: 'Lugar de grabación',
    },
    'tv-title-broadcast-date': {
        DEBUG: '[tv-title-broadcast-date]',
        EN: 'Broadcast date',
        FR: 'Date de diffusion',
        ES: 'Fecha de transmisión',
    },
    'tv-title-recording-date': {
        DEBUG: '[tv-title-recording-date]',
        EN: 'Recording date',
        FR: "Date d'enregistrement",
        ES: 'Fecha de grabación',
    },
    'tv-title-broadcast-length': {
        DEBUg: '[tv-title-broadcast-length]',
        EN: 'Broadcast length',
        FR: 'Durée de diffusion',
        ES: 'Duración de la transmisión',
    },
    'tv-title-translator_singular': {
        DEBUG: '[tv-title-translator_singular]',
        EN: 'Translator',
        FR: 'Traducteur',
        ES: 'Traductor',
    },
    'tv-title-translator_plural': {
        DEBUG: '[tv-title-translator_plural]',
        EN: 'Translators',
        FR: 'Traducteurs',
        ES: 'Traductores',
    },
    'tv-title-translation-of': {
        DEBUG: '[tv-title-translation-of]',
        EN: 'Translation of',
        FR: 'Traduction de',
        ES: 'Traducción de',
    },
    'tv-title-new-edition-of': {
        DEBUG: '[tv-title-new-edition-of]',
        EN: 'New edition of',
        FR: 'Nouvelle édition de',
        ES: 'Nueva edición de',
    },
    'tv-title-language': {
        DEBUG: '[tv-title-language]',
        EN: 'Language',
        FR: 'Langue',
        ES: 'Idioma',
    },
    'tv-title-published': {
        DEBUG: '[tv-title-published]',
        EN: 'Published',
        FR: 'Publié',
        ES: 'Publicado',
    },
    'tv-title-publisher': {
        DEBUG: '[tv-title-publisher]',
        EN: 'Publisher',
        FR: 'Maison d’édition',
        ES: 'Editorial',
    },
    'tv-title-date': {
        DEBUG: '[tv-title-date]',
        EN: 'Date',
        FR: 'Date',
        ES: 'Fecha',
    },
    'tv-title-volume': {
        DEBUG: '[tv-title-volume]',
        EN: 'Volume',
        FR: 'Volume',
        ES: 'Volumen',
    },
    'tv-title-page': {
        DEBUG: '[tv-title-page]',
        EN: 'Page',
        FR: 'Page',
        ES: 'Página',
    },
    'tv-title-issue': {
        DEBUG: '[tv-title-issue]',
        EN: 'Issue',
        FR: 'Numéro',
        ES: 'Número',
    },
    'tv-title-pages': {
        DEBUG: '[tv-title-pages]',
        EN: 'Pages',
        FR: 'Pages',
        ES: 'Páginas',
    },
    'tv-title-reprinted-chapter-of': {
        DEBUG: '[tv-title-reprinted-chapter-of]',
        EN: 'Chapters reprinted from',
        FR: 'Chapitres réimprimés de',
        ES: 'Capítulos republicados de',
    },
    'tv-title-ar': {
        DEBUG: '[tv-title-ar]',
        EN: 'Arabic',
        FR: 'Arabe',
        ES: 'Arábica',
    },
    'tv-title-hi': {
        DEBUG: '[tv-title-hi]',
        EN: 'Hindi',
        FR: 'Hindi',
        ES: 'Hindi',
    },
    'tv-title-hr': {
        DEBUG: '[tv-title-hr]',
        EN: 'Croatian',
        FR: 'Croate',
        ES: 'Croata',
    },
    'tv-title-hu': {
        DEBUG: '[tv-title-hu]',
        EN: 'Hungarian',
        FR: 'Hongrois',
        ES: 'Húngaro',
    },
    'tv-title-en': {
        DEBUG: '[tv-title-en]',
        EN: 'English',
        FR: 'Anglais',
        ES: 'Inglés',
    },
    'tv-title-as': {
        DEBUG: '[tv-title-as]',
        EN: 'Afrikaans',
        FR: 'Afrikaans',
        ES: 'Afrikaans',
    },
    'tv-title-lt': {
        DEBUG: '[tv-title-fr]',
        EN: 'Lithuanian',
        FR: 'Lituanien',
        ES: 'Lituano',
    },
    'tv-title-fr': {
        DEBUG: '[tv-title-fr]',
        EN: 'French',
        FR: 'Français',
        ES: 'Francés',
    },
    'tv-title-fa': {
        DEBUG: '[tv-title-fa]',
        EN: 'Farsi',
        FR: 'Farsi',
        ES: 'Farsi',
    },
    'tv-title-no': {
        DEBUG: '[tv-title-no]',
        EN: 'Norwegian',
        FR: 'Norvégien',
        ES: 'Noruego',
    },
    'tv-title-es': {
        DEBUG: '[tv-title-es]',
        EN: 'Spanish',
        FR: 'Espagnol',
        ES: 'Castellano',
    },
    'tv-title-et': {
        DEBUG: '[tv-title-et]',
        EN: 'Estonian',
        FR: 'Estonien',
        ES: 'Estonio',
    },
    'tv-title-fi': {
        DEBUG: '[tv-title-fi]',
        EN: 'Finnish',
        FR: 'Finnois',
        ES: 'Finlandés',
    },
    'tv-title-ca': {
        DEBUG: '[tv-title-ca]',
        EN: 'Catalan',
        FR: 'Catalan',
        ES: 'Catalan',
    },
    'tv-title-cs': {
        DEBUG: '[tv-title-cs]',
        EN: 'Czech',
        FR: 'Tchèque',
        ES: 'Checo',
    },
    'tv-title-pt': {
        DEBUG: '[tv-title-pt]',
        EN: 'Portuguese',
        FR: 'Portugaise',
        ES: 'Portugués',
    },
    'tv-title-zh': {
        DEBUG: '[tv-title-zh]',
        EN: 'Chinese',
        FR: 'Chinois',
        ES: 'Chino',
    },
    'tv-title-da': {
        DEBUG: '[tv-title-da]',
        EN: 'Danish',
        FR: 'Danois',
        ES: 'Danés',
    },
    'tv-title-de': {
        DEBUG: '[tv-title-de]',
        EN: 'German',
        FR: 'Allemand',
        ES: 'Tedesco',
    },
    'tv-title-el': {
        DEBUG: '[tv-title-el]',
        EN: 'Greek',
        FR: 'Grec',
        ES: 'Griego',
    },
    'tv-title-it': {
        DEBUG: '[tv-title-it]',
        EN: 'Italian',
        FR: 'Italien',
        ES: 'Italiano',
    },
    'tv-title-iw': {
        DEBUG: '[tv-title-iw]',
        EN: 'Hebrew',
        FR: 'Hébreu',
        ES: 'Hebreo',
    },
    'tv-title-ja': {
        DEBUG: '[tv-title-ja]',
        EN: 'Japanese',
        FR: 'Japonais',
        ES: 'Japonés',
    },
    'tv-title-nl': {
        DEBUG: '[tv-title-nl]',
        EN: 'Dutch',
        FR: 'Néerlandais',
        ES: 'Holandés',
    },
    'tv-title-sv': {
        DEBUG: '[tv-title-sv]',
        EN: 'Swedish',
        FR: 'Suedois',
        ES: 'Sueco',
    },
    'tv-title-sr': {
        DEBUG: '[tv-title-sr]',
        EN: 'Serbian',
        FR: 'Serbe',
        ES: 'Serbo',
    },
    'tv-title-tr': {
        DEBUG: '[tv-title-tr]',
        EN: 'Turkish',
        FR: 'Turc',
        ES: 'Turco',
    },
    'tv-title-uk': {
        DEBUG: '[tv-title-uk]',
        EN: 'Ukrainian',
        FR: 'Ukrainien',
        ES: 'Ucraniano',
    },
    'tv-title-he': {
        DEBUG: '[tv-title-he]',
        EN: 'Hebrew',
        FR: 'Hébreu',
        ES: 'Hebreo',
    },
    'tv-title-ka': {
        DEBUG: '[tv-title-ko]',
        EN: 'Georgian',
        FR: 'Géorgien',
        ES: 'Georgiano',
    },
    'tv-title-ko': {
        DEBUG: '[tv-title-ko]',
        EN: 'Korean',
        FR: 'Coréen',
        ES: 'Coreano',
    },
    'tv-title-id': {
        DEBUG: '[tv-title-id]',
        EN: 'Indonesian',
        FR: 'Indonésien',
        ES: 'Indonesio',
    },
    'tv-title-sl': {
        DEBUG: '[tv-title-sl]',
        EN: 'Slovenian',
        FR: 'Slovène',
        ES: 'Esloveno',
    },
    'tv-title-sq': {
        DEBUG: '[tv-title-sq]',
        EN: 'Albanian',
        FR: 'Albanais',
        ES: 'Albanés',
    },
    'tv-title-ro': {
        DEBUG: '[tv-title-ro]',
        EN: 'Romanian',
        FR: 'Roumain',
        ES: 'Rumano',
    },
    'tv-title-bg': {
        DEBUG: '[tv-title-bg]',
        EN: 'Bulgarian',
        FR: 'Bulgare',
        ES: 'Búlgaro',
    },
    'tv-title-ru': {
        DEBUG: '[tv-title-ru]',
        EN: 'Russian',
        FR: 'Russe',
        ES: 'Ruso',
    },
    'tv-title-pl': {
        DEBUG: '[tv-title-pl]',
        EN: 'Polish',
        FR: 'Polonais',
        ES: 'Polaco',
    },
    'named-container-type-translations': {
        DEBUG: '[named-container-type-translations]',
        EN: 'Translations',
        FR: 'Traductions',
        ES: 'Traducciones',
    },
    'named-container-type-radio-broadcast': {
        DEBUG: '[named-container-type-radio-broadcast]',
        EN: 'Radio Broadcast',
        FR: 'Émission de radio',
        ES: 'Programa de radio',
    },
    'side-container-header-categories': {
        DEBUG: '[side-container-header-categories]',
        EN: 'Categories',
        FR: 'Catégories',
        ES: 'Categorías',
    },
    'side-container-header-links': {
        DEBUG: '[side-container-header-links]',
        EN: 'Links',
        FR: 'Liens',
        ES: 'Enlaces',
    },
    'category-autobiographic': {
        DEBUG: '[category-autobiographic]',
        EN: 'Elements of autobiography',
        FR: "Éléments d'autobiographie",
        ES: 'Elementos de autobiografía',
    },
    'category-early-writings': {
        DEBUG: '[category-early-writings]',
        EN: 'Early writings (1934-1949)',
        FR: 'Écrits de jeunesse (1934-1949)',
        ES: 'Escritos de juventud (1934-1949)',
    },
    'category-portraits-and-obituaries': {
        DEBUG: '[category-portraits-and-obituaries]',
        EN: 'Portraits and obituaries',
        FR: 'Portraits et nécrologies',
        ES: 'Retratos y obituarios',
    },
    'category-transition-debate': {
        DEBUG: '[category-transition-debate]',
        EN: 'The transition debate',
        FR: 'Le débat sur la « transition »',
        ES: 'El debate sobre la « transición »',
    },
    'category-marxism-origins-development': {
        DEBUG: '[category-marxism-origins-development]',
        EN: 'Marxism: origins and development',
        FR: 'Marxisme: origines et développements',
        ES: 'Marxismo : orígenes y desarrollo',
    },
    'category-peasants-agrarian-societies': {
        DEBUG: '[category-peasants-agrarian-societies]',
        EN: 'Peasants and agrarian societies',
        FR: 'Paysans et sociétés agraires',
        ES: 'Campesinos y sociedades agrarias',
    },
    'category-left-britain': {
        DEBUG: '[category-left-britain]',
        EN: 'The left in Britain',
        FR: 'La gauche britannique',
        ES: 'La izquierda británica',
    },
    'category-central-europe': {
        DEBUG: '[category-central-europe]',
        EN: 'Central Europe',
        FR: 'L’Europe centrale',
        ES: 'Sobre Europa central',
    },
    'category-communism': {
        DEBUG: '[category-communism]',
        EN: 'Communism',
        FR: 'Le communisme',
        ES: 'El comunismo',
    },
    'category-bandits-and-gangsters': {
        DEBUG: '[category-bandits-and-gangsters]',
        EN: 'Bandits and gangsters',
        FR: 'Bandits et gangsters',
        ES: 'Bandidos y gángsters',
    },
    'category-revolutions-and-revolutionaries': {
        DEBUG: '[category-revolutions-and-revolutionaries]',
        EN: 'Revolutions and revolutionaries',
        FR: 'Révolutions et révolutionnaires',
        ES: 'Revoluciones y revolucionarios',
    },
    'category-labour-history': {
        DEBUG: '[category-labour-history]',
        EN: 'Labour history',
        FR: 'L’histoire du travail et du monde ouvrier',
        ES: 'La historia del trabajo y del mundo obrero',
    },
    'category-capitalism-origins-developments-results': {
        DEBUG: '[category-capitalism-origins-developments-results]',
        EN: 'Capitalism: origins, developments, results',
        FR: 'Capitalisme: origines, développements, conséquences',
        ES: 'Capitalismo: orígenes, desarrollo, consecuencias',
    },
    'category-nations-and-nationalism': {
        DEBUG: '[category-nations-and-nationalism]',
        EN: 'Nations and nationalism',
        FR: 'Nations et nationalismes',
        ES: 'Naciones y nacionalismo',
    },
    'category-globalization': {
        DEBUG: '[category-globalization]',
        EN: 'Globalisation',
        FR: 'La mondialisation',
        ES: 'La globalización',
    },
    'category-historical-method': {
        DEBUG: '[category-historical-method]',
        EN: 'Historical method',
        FR: 'Histoire: méthode et historiographie',
        ES: 'Método histórico y historiografia',
    },
    'category-latin-america': {
        DEBUG: '[category-latin-america]',
        EN: 'Latin America',
        FR: 'L’Amérique latine',
        ES: 'Latino América',
    },
    'category-jazz': {
        DEBUG: '[category-jazz]',
        EN: 'Jazz',
        FR: 'Le jazz',
        ES: 'Jazz',
    },
    'category-art-literature-cinema': {
        DEBUG: '[category-art-literature-cinema]',
        EN: 'Art, literature and cinema',
        FR: 'Art, littérature et cinéma',
        ES: 'Arte, literatura y cine',
    },
    'category-appraising-hobsbawm': {
        DEBUG: '[category-appraising-hobsbawm]',
        EN: 'Appraising Hobsbawm',
        FR: 'Perspectives critiques sur Hobsbawm',
        ES: 'Perspectivas críticas sobre Hobsbawm',
    },
    'personrole_author_analytic_newspaper-article': {
        DEBUG: '[personrole_author_analytic_newspaper-article]',
        EN: 'Author of newspaper article',
        FR: "Auteur d'article dans un journal",
        ES: 'Autor de un artículo en un periódico',
    },
    'personrole_author_monogr_book-chapter': {
        DEBUG: '[personrole_author_monogr_book-chapter]',
        EN: 'Author of book',
        FR: 'Auteur de livre',
        ES: 'Autor de libro',
    },
    'personrole_translator_monogr_book': {
        DEBUG: '[personrole_translator_monogr_book',
        EN: 'Translator of book',
        FR: 'Traducteur de livre',
        ES: 'Traductor de libro',
    },
    'personrole_translator_monogr_book-chapter': {
        DEBUG: '[personrole_translator_monogr_book-chapter]',
        EN: 'Translator of book',
        FR: 'Traducteur de livre',
        ES: 'Traductor de libro',
    },
    'personrole_editor_monogr_book-chapter': {
        DEBUG: '[personrole_editor_monogr_book-chapter]',
        EN: 'Editor of volume (in which Hobsbawm wrote a chapter)',
        FR:
            "Direction d'ouvrage collectif (dans lequel Hobsbawm a écrit une chapitre)",
        ES:
            'Editor de un trabajo colectivo (en el cual Hobsbawm escribió un capítulo)',
    },
    'personrole_editor_monogr_edited-volume': {
        DEBUG: '[personrole_editor_monogr_book-chapter]',
        EN: 'Co-editor of a volume (with Hobsbawm)',
        FR: "Co-direction d'un ouvrage collectif (avec Hobsbawm)",
        ES: 'Co-editor de un trabajo colectivo (con Hobsbawm)',
    },
    'personrole_author_analytic_journal-article': {
        DEBUG: '[personrole_author_analytic_journal-article]',
        EN: 'Author of Journal Article',
        FR: "Auteur d'article de revue",
        ES: 'Autor de artículo de revista',
    },
    'personrole_author_monogr_book-review': {
        DEBUG: '[personrole_author_monogr_book-review]',
        EN: 'Author of book reviewed by Hobsbawm',
        FR: 'Auteur de livre dont Hobsbawm a fait une critique',
        ES: 'Autor de libro que Hobsbawm reseñó',
    },
    'personrole_editor_monogr_book-review': {
        DEBUG: '[personrole_editor_monogr_book-review]',
        EN: 'Editor of book reviewed by Hobsbawm',
        FR: 'Direction de livre dont Hobsbawm a fait une critique',
        ES: 'Editor de libro que Hobsbawm reseñó',
    },
    'personrole_author_monogr_book': {
        DEBUG: '[personrole_author_monogr_book]',
        EN: 'Co-author',
        FR: 'Coauteur',
        ES: 'Coautor',
    },
    'personrole_author_analytic_book-review': {
        DEBUG: '[personrole_author_analytic_book-review]',
        EN: 'Author of book review',
        FR: 'Auteur de critique de livre',
        ES: 'Autor de reseña de libro',
    },
    'personrole_author_analytic_review-article': {
        DEBUG: '[personrole_author_analytic_review-article]',
        EN: 'Author of review article',
        FR: 'Auteur de recension de multiples ouvrages',
        ES: 'Autor de un artículo de revisión',
    },
    'personrole_author_analytic_book-chapter': {
        DEBUG: '[personrole_author_analytic_book-chapter]',
        EN: 'Author of book chapter',
        FR: 'Auteur de chapitre de livre',
        ES: 'Autor de capítulo de libro',
    },
    'pseudo_of_hobsbawm': {
        DEBUG: '[pseudo_of_hobsbawm]',
        EN: 'pseudonym of Eric Hobsbawm',
        FR: "pseudonyme d'Eric Hobsbawm",
        ES: 'seudónimo de Eric Hobsbawm',
    },
    'include': {
        DEBUG: '[include]',
        EN: 'Include',
        FR: 'Inclure',
        ES: 'Incluir',
    },
    'exclude': {
        DEBUG: '[exclude]',
        EN: 'Exclude',
        FR: 'Exclure',
        ES: 'Excluir',
    },
    'bbc-website': {
        DEBUG: '[bbc-website]',
        EN: 'BBC Website',
        FR: 'site de la BBC',
        ES: 'Sitio web de la BBC',
    },
    'web-citation': {
        DEBUG: '[web-citation]',
        EN: 'Web Citation',
        FR: 'Citation Web',
        ES: 'Cita web',
    },
    'worldcat': {
        DEBUG: '[WorldCat]',
        EN: 'WorldCat',
        FR: 'WorldCat',
        ES: 'WorldCat',
    },
    'archive-catalogue': {
        DEBUG: '[archive-catalogue]',
        EN: 'Archive Catalogue',
        FR: "Catalogue d'archive",
        ES: 'Catálogo de archivo',
    },
    'marx-memorial-library-catalogue': {
        DEBUG: '[marx-memorial-library-catalogue]',
        EN: 'Marx Memorial Library Catalogue',
        FR: 'Catalogue de la Marx Memorial Library a Londres',
        ES: 'Catálogo de la Marx Memorial Library en Londres',
    },
    'jstor': {
        DEBUG: '[jstor]',
        EN: 'JSTOR',
        FR: 'JSTOR',
        ES: 'JSTOR',
    },
    'newleftreview': {
        DEBUG: '[newleftreview]',
        EN: 'New Left Review',
        FR: 'New Left Review',
        ES: 'New Left Review',
    },
    'monthly-review-archive': {
        DEBUG: '[monthly-review-archive]',
        EN: 'Monthly Review Archive',
        FR: 'Monthly Review Archive',
        ES: 'Monthly Review Archive',
    },
    'journal-archive': {
        DEBUG: '[journal-archive]',
        EN: 'Journal Archive',
        FR: 'Archive de revue',
        ES: 'Archivo de revista',
    },
    'journal-catalogue': {
        DEBUG: '[journal-catalogue]',
        EN: 'Journal Catalogue',
        FR: 'Catalogue de revue',
        ES: 'Catálogo de revista',
    },
    'outlookindia': {
        DEBUG: '[outlookindia]',
        EN: 'Outlook India',
        FR: 'Outlook India',
        ES: 'Outlook India',
    },
    'inatheque-paris': {
        DEBUG: '[inatheque-paris]',
        EN: 'Inathèque Paris',
        FR: 'Inathèque Paris',
        ES: 'Inathèque Paris',
    },
    'cattext_autobiographic': {
        DEBUG: '[cattext_autobiographic]',
        EN:
            'A selection of texts that give a sense of Hobsbawm’s\n    biography. They include his memoir,\n    <i>Interesting Times</i> (2002), as well as\n    interviews and articles in which he reflected on his\n    own life and work.',
        FR:
            'Une sélection de textes qui donnent un aperçu biographique \n        de Hobsbawm. Outre ses mémoires, <i>Interesting Times</i> (2002),\n        cette liste inclut de nombreux interviews et articles dans lesquels\n         il parle de sa vie et de ses travaux. ',
        ES:
            'Una selección de textos que dan una visión biográfica de Hobsbawm. \n        Además de sus memorias, <i>Interesting Times</i> (2002), esta lista incluye entrevistas y\n         artículos en las cuales hable de su vida y su trabajo.',
    },
    'cattext_early-writings': {
        DEBUG: '[cattext_early-writing]',
        EN:
            'A selection of writings from Hobsbawm’s teenage and student years. Many of these are book reviews, but they also include short essays, creative writing, and political pamphlets. ',
        FR:
            'Une sélection d’écrits de jeunesse de Hobsbawm. La plupart date sont des critiques de livres rédigées pendant ses études à Cambridge, mais la liste comprend également des essais, des nouvelles et des tracts politiques.',
        ES:
            'Una selección de textos y escritos de la juventud de Hobsbawm. La mayoría son reseñas de libros escritas mientras estudiaba en Cambridge, pero la lista también incluye ensayos, cuentos y tratados políticos.',
    },
    'cattext_portraits-and-obituaries': {
        DEBUG: '[cattext_portraits-and-obituaries]',
        EN:
            'By virtue of his long life, Hobsbawm became one of the foremost chroniclers of his generation of left-wing intellectuals. This is a selection of his portraits and obituaries from the 1930s to the 2010s. ',
        FR:
            'Grâce notamment à sa longévité, Hobsbawm est devenu l’un des plus importants chroniqueurs de sa génération d’intellectuels de gauche. Voici donc une sélection de ses portraits et nécrologies des années 1930 aux années 2010.',
        ES:
            'Gracias en parte a su longevidad, Hobsbawm se convirtió en uno de los cronistas más importantes de su generación de intelectuales de izquierda. Aquí hay una selección de sus retratos y obituarios desde la década de 1930 hasta la de 2010.',
    },
    'cattext_historical-method': {
        DEBUG: '[cattext_historical-method]',
        EN:
            'Hobsbawm was a historian by training and by profession. This selection of material gives an insight into his approach to history and historical method. ',
        FR:
            'Hobsbawm était historien de formation et de profession. Cette sélection de textes donne un aperçu de sa méthode historique et de sa vision historiographique.',
        ES:
            'Hobsbawm fue historiador por formación y por profesión. Esta selección de textos ofrece una visión general de su método histórico y su manera de abordar los problemas historiográficos.',
    },
    'cattext_transition-debate': {
        DEBUG: '[cattext_transition-debate]',
        EN:
            'Hobsbawm was an important contributor to the debate surrounding the “transition” from feudalism to capitalism, which was a major controversy in Marxist theory in the 1950s, 1960s and 1970s. This selection of articles and essays chronicles his various interventions.',
        FR:
            'Hobsbawm a joué un rôle important dans le débat sur la « transition » entre le féodalisme et le capitalisme qui a été une discussion majeure dans les milieux marxistes des années 50, 60 et 70. Cette sélection d’articles et d’essais retrace ses différentes interventions.',
        ES:
            'Hobsbawm jugó un papel importante en el debate sobre la “transición” entre el feudalismo y el capitalismo que fue una discusión importante en los círculos marxistas de los años 50, 60 y 70. Esta selección de artículos y ensayos remonta sus intervenciones distintas.',
    },
    'cattext_capitalism-origins-developments-results': {
        DEBUG: '[cattext_capitalism-origins-developments-results]',
        EN:
            'Hobsbawm devoted a significant part of his early work to the history of capitalism. This selection of publications gives a sense of the range and scope of his writings on the subject.',
        FR:
            'Hobsbawm a consacré une partie importante de ses premiers travaux à l’histoire du capitalisme. Cette sélection de publications donne une idée de l’étendue et de la portée de ses écrits dans ce domaine.',
        ES:
            'Hobsbawm dedicó una parte importante de sus primeros trabajos a la historia del capitalismo. Esta selección de publicaciones da una idea del alcance de sus escritos en esta área.',
    },
    'cattext_peasants-agrarian-societies': {
        DEBUG: '[cattext_peasants-agrarian-societies]',
        EN:
            'From the mid-1950s to the 1980s, Hobsbawm maintained a strong interest in the history, anthropology and sociology of agrarian societies both past and present. This selection of material &mdash; both book-length and short-form &mdash; documents the work he did on the subject.',
        FR:
            'A partir des années 1950, Hobsbawm s’intéresse de plus en plus à l’histoire, l’anthropologie et la sociologie des paysans et des sociétés agraires. Cette sélection d’articles et de livres rend compte du travail qu’il a fait dans ce domaine.',
        ES:
            'Desde la década de 1950, Hobsbawm se interesó cada vez más en la historia, la antropología y la sociología de los campesinos y las sociedades agrarias. Esta selección de artículos y libros refleja el trabajo que ha realizado en esta área.',
    },
    'cattext_bandits-and-gangsters': {
        DEBUG: '[cattext_bandits-and-gangsters]',
        EN:
            'This is a selection of Hobsbawm’s work on bandits, gangsters and “primitive rebels”. Hobsbawm was often credited with revitalizing this historical field thanks to his pioneering essays in <em>Primitive Rebels</em> (1959). ',
        FR:
            'Ceci est une sélection des travaux de Hobsbawm sur les bandits, les gangsters et les « primitifs de la révolte ». Hobsbawm a été reconnu pour avoir revitalisé ce champ de recherche grâce notamment à ses essais pionniers dans <em>Primitive Rebels</em> (1959).',
        ES:
            'Esta es una selección del trabajo de Hobsbawm sobre bandidos, gángsters y “rebeldes primitivos”. Hobsbawm ha sido reconocido por revitalizar este campo de investigación gracias en particular a sus ensayos pioneros en <em>Primitive Rebels</em> (1959).',
    },
    'cattext_labour-history': {
        DEBUG: '[cattext_labour-history]',
        EN:
            'Hobsbawm began his career as a labour historian. Much of his early work is devoted to the lives and conditions of the English working-class in the 18<sup style="font-size: 9px">th</sup> and 19<sup style="font-size: 9px">th</sup> centuries. This selection of books and essays charts the evolution of his thought on the subject from the 1940s to the 2000s. ',
        FR:
            'Les premières recherches historiques de Hobsbawm portent sur la société et les conditions de vie de la classe ouvrière anglaise aux XVIIIe et XIXe siècles. Cette sélection de livres et d’essais retrace l’évolution de sa réflexion sur le sujet des années 40 aux années 2000.',
        ES:
            'Las primeras investigaciones históricas de Hobsbawm se centrararon en la sociedad y las condiciones de vida del mundo obrero inglés del siglo XVIII y XIX. Esta selección de libros y ensayos traza la evolución de su pensamiento sobre este tema desde la década de 1940 hasta la década de 2000.',
    },
    'cattext_nations-and-nationalism': {
        DEBUG: '[cattext_nations-and-nationalism]',
        EN:
            'Hobsbawm took a sustained interest in the history of nationalism and national identity from the 1980s onwards. This selection of texts gives an insight into how his ideas developed. ',
        FR:
            'Hobsbawm s’intéresse de façon soutenue à l’histoire du nationalisme et de l’identité nationale à partir des années 1980. Cette sélection de textes donne un aperçu de l’évolution de ses idées.',
        ES:
            'Hobsbawm se interesó en la historia del nacionalismo y la identidad nacional a partir de la década de 1980. Esta selección de textos ofrece una visión general del desarrollo de sus ideas.',
    },
    'cattext_marxism-origins-development': {
        DEBUG: '[cattext_marxism-origins-development]',
        EN:
            'Hobsbawm was not only a Marxist in his political orientation; he was also a scholar of Marx. Although he is not well known as a historian of political thought, his writings on Marx amounted to a significant body of work over his career.',
        FR:
            'Hobsbawm n’était pas seulement marxiste dans son orientation politique ; il était également un érudit de Marx. Même s’il n’est pas connu principalement comme historien de la pensée politique, ses écrits sur Marx constitue un corpus important de travaux au cours de sa carrière.',
        ES:
            'Hobsbawm no solo era marxista en su orientación política; también fue un erudito de Marx. Aunque no sea conocido principalmente como historiador del pensamiento político, sus escritos sobre Marx constituyen un importante corpus de trabajo.',
    },
    'cattext_communism': {
        DEBUG: '[cattext_communism]',
        EN:
            'As a life-long communist, Hobsbawm was often called upon to write about or comment upon the past and present of the Communist movement. This selection of texts, which ranges from full-length essays to short book reviews, gives an insight into how he related to Communism at different points in his life. ',
        FR:
            'En tant que communiste, Hobsbawm a été souvent appelé à commenter le passé et le présent du mouvement communiste. Cette sélection d’articles, critiques et essais donne un aperçu de la façon dont il a discuté du communisme dans des contextes divers.',
        ES:
            'Como comunista, a Hobsbawm se le pidió a menudo que escribiera sobre el pasado y el presente del movimiento comunista. Esta selección de artículos, reseñas y ensayos da una idea de cómo discutió el comunismo en varios contextos distintos.',
    },
    'cattext_revolutions-and-revolutionaries': {
        DEBUG: '[cattext_revolutions-and-revolutionaries]',
        EN:
            'A selection of Hobsbawm’s texts relating to the history of revolution and revolutionaries, many of which took the form of short essay, reviews and portraits. ',
        FR:
            'Une sélection de textes de Hobsbawm relatifs à l’histoire de la révolution et des révolutionnaires. La majorité sont en forme de courts essais, de critiques et de portraits.',
        ES:
            'Una selección de textos de Hobsbawm relacionados con la historia de la revolución y los revolucionarios. La mayoría se presenta en forma de ensayos cortos, reseñas y retratos.',
    },
    'cattext_left-britain': {
        DEBUG: '[cattext_left-britain]',
        EN:
            'As one of the foremost intellectuals in Britain, Hobsbawm was often called upon to write about the history and contemporary struggles of the British left. This list includes a varied selection of his writings on this subject, from his doctoral dissertation to opinion articles in major British newspapers. ',
        FR:
            'En tant qu’intellectuel, Hobsbawm est souvent appelé à écrire sur l’histoire et les luttes contemporaines de la gauche britannique. Cette liste comprend une sélection variée de ses écrits sur ce sujet, de sa thèse doctorale aux articles d’opinion dans des journaux britanniques.',
        ES:
            'Como intelectual, Hobsbawm a menudo ha sido llamado a escribir sobre la historia y las luchas contemporáneas de la izquierda británica. Esta lista incluye una variada selección de sus escritos sobre este tema, desde su tesis doctoral hasta artículos de opinión en periódicos británicos.',
    },
    'cattext_latin-america': {
        DEBUG: '[cattext_latin-america]',
        EN:
            'Hobsbawm travelled to continental Latin America for the first time in the early 1960s. From then on, he became a witness and chronicler of some of the continent’s most tumultuous political events. This selection of essays and articles showcases his writing on Latin America, much of which was journalistic in style.',
        FR:
            'Hobsbawm visite l’Amérique latine pour la première fois au début des années 1960. Dès lors, il devient témoin et chroniqueur de nombreux événements politiques sur le continent. Cette sélection d’essais et d’articles présente ses écrits sur l’Amérique latine, la plupart rédigés dans un style journalistique.',
        ES:
            'Hobsbawm visitó América Latina por primera vez a principios de la década de 1960 y se convirtió pronto en testigo y cronista de muchos eventos políticos en el continente. Esta selección incluye la gran mayoría de los ensayos y artículos que publicó sobre América Latina.',
    },
    'cattext_central-europe': {
        DEBUG: '[cattext_central-europe]',
        EN:
            'Hobsbawm was brought up in interwar Vienna and Berlin, and he was a fluent German speaker. This selection brings to light some of his little-known writings on central Europe, many of which are in German.',
        FR:
            'Hobsbawm a grandi à Vienne et à Berlin dans les années 20 et 30, et il parlait couramment l’allemand. Cette sélection met en lumière ses écrits peu connus sur l’Europe centrale, dont beaucoup sont en allemand.',
        ES:
            'Hobsbawm creció en Viena y Berlín en las décadas de 1920 y 1930, y hablaba alemán con fluidez. Esta selección destaca sus escritos poco conocidos sobre Europa Central, muchos de los cuales son en alemán.',
    },
    'cattext_globalization': {
        DEBUG: '[cattext_globalization]',
        EN:
            'Hobsbawm was always a global historian, but he became actively interested in the past and present of globalization in the 1990s. This selection of writings and interviews charts his interventions on the subject.  ',
        FR:
            'Hobsbawm a toujours été un historien avec une vision globale, mais il s’est intéressé activement au passé et au présent de la mondialisation dans les années 90. Cette sélection d’écrits et d’entretiens retrace ses interventions dans ce domaine.',
        ES:
            'Hobsbawm siempre fue un historiador con una visión global, pero se interesó activamente en el pasado y el presente de la globalización en la década de 1990. Esta selección de escritos y entrevistas da una idea de sus intervenciones en esta área.',
    },
    'cattext_jazz': {
        DEBUG: '[cattext_jazz]',
        EN:
            'A selection of Hobsbawm’s writing on jazz, the vast majority of which was originally published in the <em>New Statesman</em> in the 1950s and 1960s. During this time, he was one of the magazine’s jazz correspondents under the pseudonym Francis Newton. ',
        FR:
            'Une sélection d’écrits de Hobsbawm sur le jazz, dont la grande majorité a été initialement publiée dans la revue <em>New Statesman</em> dans les années 50 et 60. À cette époque, il était l’un des correspondants jazz du magazine sous le pseudonyme Francis Newton.',
        ES:
            'Una selección de los escritos de Hobsbawm sobre jazz, la gran mayoría de los cuales fueron publicados originalmente en la revista <em>New Statesman</em> en las décadas de 1950 y 1960. En ese momento, era uno de los corresponsales de jazz de la revista bajo el seudónimo de Francis Newton.',
    },
    'cattext_art-literature-cinema': {
        DEBUG: '[cattext_art-literature-cinema]',
        EN:
            'Hobsbawm maintained an interest in art, literature and cinema throughout his life. This eclectic selection of written material &mdash; ranging from student movie reviews to exhibition catalogues &mdash; highlights some of his knowledge and opinions about all three genres. ',
        FR:
            'Hobsbawm s’est intéressé à l’art, la littérature et le cinéma tout au long de sa vie. Cette sélection éclectique de documents écrits &mdash; y compris des critiques de films et des catalogues d’exposition &mdash; donne une idée de ses arguments et de ses opinions dans ce domaine.',
        ES:
            'Hobsbawm se interesó en el arte, la literatura y el cine a lo largo de su vida. Esta selección ecléctica de material escrito, que incluye reseñas de películas y catálogos de exposiciones, da una idea de sus argumentos y opiniones en esta área.',
    },
    'cattext_appraising-hobsbawm': {
        DEBUG: '[cattext_appraising-hobsbawm]',
        EN:
            'A selection of critical and biographical writings on Hobsbawm’s life and work.',
        FR:
            'Une sélection d’écrits critiques et biographiques sur la vie et l’œuvre de Hobsbawm.',
        ES:
            'Una selección de escritos críticos y biográficos sobre la vida y la obra de Hobsbawm.',
    },
};
